var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgThumbnailMissing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "69px",
    viewBox: "0 0 55 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_find_in_page_24px copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File-type-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.499646868
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preview-missing",
    transform: "translate(-8.000000, -7.000000)",
    fill: "#003976",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_find_in_page_24px-copy",
    transform: "translate(8.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,60.6855 L55,20.7 L34.375,0 L6.875,0 C3.09375,0 0.034375,3.105 0.034375,6.9 L0,62.1 C0,65.895 3.059375,69 6.840625,69 L48.125,69 C49.671875,69 51.046875,68.4825 52.215625,67.62 L36.9875,52.3365 C34.2375,54.1305 31.00625,55.2 27.5,55.2 C18.0125,55.2 10.3125,47.472 10.3125,37.95 C10.3125,28.428 18.0125,20.7 27.5,20.7 C36.9875,20.7 44.6875,28.428 44.6875,37.95 C44.6875,41.469 43.621875,44.712 41.834375,47.4375 L55,60.6855 Z M17.1875,37.95 C17.1875,43.677 21.79375,48.3 27.5,48.3 C33.20625,48.3 37.8125,43.677 37.8125,37.95 C37.8125,32.223 33.20625,27.6 27.5,27.6 C21.79375,27.6 17.1875,32.223 17.1875,37.95 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailMissing);
export default __webpack_public_path__ + "static/media/thumbnail_missing.88c8531649ef9738211cc09e74bac37a.svg";
export { ForwardRef as ReactComponent };